<template>
    <client-page class="wrap--sub">
        <sub-visual :visual="typeName" :class="typeClass" />

        <div class="contents">
            <div class="container">
                <template v-if="isAuthorized">
                    <div class="board-container">
                        <div class="mb-60 mb-md-40">
                            <view-request :request="request" :isLong="isLong" />
                        </div>
                        <div>
                            <view-responses v-model="request" />
                        </div>

                        <div class="board-buttons board-buttons--right-center mt-30 mt-md-20">
                            <div class="left"></div>
                            <div class="right">
                                <v-btn v-if="isRequester" outlined color="red" @click="remove">삭제</v-btn>
                                <v-btn v-if="isRequester" outlined color="gray-9" @click="$router.push(`${$route.path}/modify`)">수정</v-btn>
                                <counsel-report v-if="isCounselor" :request="request" />
                                <v-btn color="gray-9" @click="$router.push(`/counsel/${type}/`)">목록</v-btn>
                            </div>
                        </div>

                        <div v-if="request.isDone" class="card card--primary text-center mt-70 mt-md-30 py-5 py-md-7">
                            <p class="text-16 text-md-14 color-gray-2 font-weight-bold">자문요청이 종료되었습니다.</p>
                        </div>
                        <div v-else-if="isRequester && !isLong" class="card card--primary text-center mt-70 mt-md-30 py-5 py-md-7">
                            <p class="text-16 text-md-14 color-gray-2 font-weight-bold mb-15 mb-md-10">자문단의 답변이 충분히 도움이 되었다면 자문종료 처리를 해주시기 바랍니다.</p>
                            <v-btn color="primary" @click="complete">자문요청 종료</v-btn>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <div class="card card--primary">
                        <p class="text-18 text-md-16 font-weight-medium">권한이 없습니다.</p>
                    </div>
                </template>
            </div>
        </div>
    </client-page>
</template>

<script>
import api from "@/api";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import ClientPage from "../../templates/ClientPage.vue";
import ViewRequest from "@/components/client/counsel/view-request.vue";
import ViewResponses from "@/components/client/counsel/view-responses/view-responses.vue";
import { COUNSEL_REQUEST_TYPES } from "@/assets/data/CONSTANTS";
import CounselReport from "@/components/client/counsel/counsel-report/counsel-report.vue";

export default {
    components: { ClientPage, SubVisual, ViewRequest, ViewResponses, CounselReport },
    computed: {
        type() {
            return this.$route?.params?.type;
        },
        typeClass() {
            if (this.type == "short") return "sv3";
            if (this.type == "long") return "sv4";
            return "";
        },
        typeName() {
            if (this.type == "short") return "이음자문";
            if (this.type == "long") return "멘토링";
            return "";
        },
        isLong() {
            return this.type == "long";
        },
        _counselRequest() {
            return this.$route.params?._counselRequest;
        },
        isAuthorized() {
            if (this.request == null) return undefined;
            else if (this.request) return true;
            else return false;
        },
        isRequester() {
            return this.request?._requester == this.$store.state.payload._user;
        },
        isCounselor() {
            return this.request?._requestees?.includes(this.$store.state.payload._user);
        },
    },
    data() {
        return {
            request: null,
        };
    },
    methods: {
        async search() {
            try {
                const { counselRequest } = await api.v1.counsels.get({ _id: this._counselRequest });
                this.request = counselRequest;

                if (counselRequest.type == COUNSEL_REQUEST_TYPES.LONG && this.type !== "long") this.$router.replace(`/counsel/long/${counselRequest._id}`);
                if (counselRequest.type == COUNSEL_REQUEST_TYPES.SHORT && this.type !== "short") this.$router.replace(`/counsel/short/${counselRequest._id}`);
            } catch (error) {
                this.$handleError(error);
            }
        },
        async remove() {
            try {
                const go = confirm("요청을 삭제하시겠습니까?");
                if (go) {
                    const { counselRequest } = await api.v1.counsels.delete({ _id: this._counselRequest });
                    alert("요청이 삭제되었습니다.");
                    this.$router.push(`/counsel/${this.type}`);
                }
            } catch (error) {
                this.$handleError(error);
            }
        },
        async complete() {
            try {
                const go = confirm("자문요청을 종료하시겠습니까?");
                if (go) {
                    const { counselRequest } = await api.v1.counsels.put({ _id: this._counselRequest, isDone: true });
                    this.request = counselRequest;
                    alert("자문요청이 종료되었습니다.");
                }
            } catch (error) {
                this.$handleError(error);
            }
        },
    },
    mounted() {
        this.search();
    },
};
</script>

<style></style>
